<template>
  <div class="share-cta">
    <div class="text-center">
      <v-btn
        @click="openNewMemoryDialog"
        elevation="0"
        color="red"
        class="share-memory-btn"
        >Share Your Memories</v-btn
      >
      <v-dialog
        persistent
        max-width="990"
        v-if="memoryPageDialog"
        v-model="memoryPageDialog"
      >
        <v-card class="memory-form-v-card">
          <MemoryForm @close="memoryPageDialog = false" />
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import MemoryForm from "@/components/Memory/MemoryForm";

export default {
  name: "ShareYourMemory",
  components: { MemoryForm },
  data() {
    return {
      memoryPageDialog: false
    };
  },
  methods: {
    openNewMemoryDialog() {
      this.memoryPageDialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.memory-form-v-card {
  background-image: url(~@/assets/agenda_bg.jpg);
  background-position: center;
  background-size: cover;
}

.share-cta {
  text-align: center;
  margin-bottom: 60px;

  &__memory-label {
    color: $stjude-red;
    padding: 0 80px 10px;
    border-bottom: 2px solid #dcdce1;
  }
}

a {
  color: white;
}

.share-memory-btn {
  color: white;
}

@media screen and (max-width: 960px) {
  .share-cta {
    &::v-deep {
      .v-btn:not(.v-btn--round).v-size--default.share-memory-btn {
        font-size: 16px;
        height: 36px;
        padding: 0 22px;
      }
    }
  }
}
</style>
